import axios from 'axios';

//const API_URL = "https://gpsdogstracking.com:3003/api/auth/";

const API_URL = "https://gpsdogstracking.com/api/auth/";

/*
const httpsAgent = new https.Agent({
  rejectUnauthorized: false, // (NOTE: this will disable client verification)
  key: fs.readFileSync('/etc/letsencrypt/live/gpsdogstracking.com/privkey.pem'), // Replace with the path to your key
  cert: fs.readFileSync('/etc/letsencrypt/live/gpsdogstracking.com/fullchain.pem'), // Replace with the path to your certificate
  passphrase: "goldman"
})
*/

const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

export default {
  register,
  login,
  logout,
};
